module.exports = __webpack_public_path__ + "static/media/bg2.3cb0f071.jpeg";